import { createRoute, Outlet, useRouterState } from '@tanstack/react-router'

import { activeNavigationItem, ProductGuard } from '@/app/routes/area-layout'
import { PermissionGate } from '@/ui/permission-gate'
import { NoAccess } from '@/ui/no-access'
import { adminRoute } from '@/modules/hierarchy'

export function IamRouteGuard() {
  const destination = useRouterState({
    select: (state) => activeNavigationItem('admin', state.matches.at(-1)?.fullPath),
  })

  return (
    <ProductGuard product="admin">
      {destination?.permission ? (
        <PermissionGate permission={destination.permission}>
          <Outlet />
        </PermissionGate>
      ) : (
        <NoAccess />
      )}
    </ProductGuard>
  )
}

export const iamGuardRoute = createRoute({
  getParentRoute: () => adminRoute,
  id: 'iam-guard',
  component: IamRouteGuard,
})
